module.exports = __webpack_public_path__ + "assets/img/GESTIONDEPEDIDOS.3065c621.svg";